import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ViewSDKClient } from '../../../services/ViewSDKClient.service';

@Component({
  selector: 'app-documentdetails',
  templateUrl: './documentdetails.component.html',
  styleUrls: ['./documentdetails.component.css'],
})
export class DocumentdetailsComponent implements OnChanges {
  @Input() currentDocument: {
    FinalUrl?: string;
    filename?: string;
    title?: string;
    minuteType?: 'DRAFT' | 'FINAL' | null;
  } | null;
  @Input() meetingObject: any;
  @Input() canVoteMinutes = false;
  /** When opened from director dashboard Documents (no list to go back to). */
  @Input() documentPdfOnlyMode = false;
  @Output() dismissRequested = new EventEmitter<void>();

  constructor(private viewSDKClient: ViewSDKClient) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentDocument'] && this.currentDocument?.FinalUrl) {
      this.viewSDKClient.ready().then(() => {
        this.viewSDKClient.previewFile(
          'document-pdf-div',
          {},
          this.currentDocument.FinalUrl,
          this.currentDocument.filename || this.currentDocument.title || 'Document'
        );
      });
    }
  }

  get meetingIdForVote(): string {
    return (this.meetingObject && (this.meetingObject._id || this.meetingObject.meetingId)) || '';
  }

  onBackClick() {
    if (this.documentPdfOnlyMode) {
      this.dismissRequested.emit();
      return;
    }
    this.showDocumentsList();
  }

  showDocumentsList() {
    const setDisplay = (elId: string, visible: boolean) => {
      const el = document.getElementById(elId);
      if (el) {
        el.style.display = visible ? 'block' : 'none';
      }
    };
    setDisplay('documentDetails', false);
    setDisplay('Document', true);
    setDisplay('Agenda', false);
    setDisplay('Attendance', false);
    setDisplay('individual-meeting', false);
    setDisplay('agendaAnalytics', false);
    setDisplay('agendaDetails', false);
  }
}
